import {
  fetchEnterpriseWorkspaceAnalytics,
  fetchEnterpriseWorkspaceInterventions,
  fetchEnterpriseWorkspaceObservability,
  fetchEnterpriseWorkspaceTimeline,
} from './enterprise-api';

export async function loadWorkspaceTimeline(accessToken: string, organizationId: string, limit = 180) {
  return fetchEnterpriseWorkspaceTimeline(accessToken, organizationId, limit);
}

export async function loadWorkspaceInterventions(accessToken: string, organizationId: string, days = 30) {
  return fetchEnterpriseWorkspaceInterventions(accessToken, organizationId, days);
}

export async function loadWorkspaceAnalytics(accessToken: string, organizationId: string) {
  return fetchEnterpriseWorkspaceAnalytics(accessToken, organizationId);
}

export async function loadWorkspaceObservability(accessToken: string, organizationId: string) {
  return fetchEnterpriseWorkspaceObservability(accessToken, organizationId);
}
